<template>
  <v-container>
    <h1 class="text-center text-uppercase">STORE ROOM</h1>
    <v-row class="text-center">
      <v-col>
        <v-btn color="primary1" dark @click="$router.replace('/PURCHASE_ORDER')">PURCHASE ORDER</v-btn>
      </v-col>
      <v-col>
        <v-btn icon @click="getStock">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="STOCKROOM"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.in_date="{ item }">
        <p>
          {{
          item.in_date | DateAndTime
          }}
        </p>
      </template>
      <template v-slot:item.createdon="{ item }">
        <p>
          {{
          item.createdon | date
          }}
        </p>
      </template>
      <template v-slot:item.billrate="{ item }">
        <p>
          {{
          item.billrate | rupee
          }}
        </p>
      </template>
      <template v-slot:item.uniq_id="{ item }">
        <v-icon color="primary1" @click="viewStock(item.uniq_id)">mdi-eye</v-icon>
      </template>
      <template v-slot:item.id="{ item }">
        <v-icon color="error" @click="deleteStock(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="newStock" persistent scrollable max-width="50%">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">NEW STOCK</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-autocomplete
                v-model="s_product"
                :rules="[RULES.required]"
                :items="PRODUCTS"
                item-text="name"
                item-value="pid"
                label="Product"
              ></v-autocomplete>
              <div>
                <v-menu
                  ref="menu"
                  v-model="datemenu"
                  :close-on-content-click="false"
                  :return-value.sync="indate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="indate"
                      label="INVOICE date"
                      prepend-icon="mdi-calendar-check"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="indate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datemenu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(indate)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Amount Paid ₹"
                    required
                    v-model="s_mrp"
                    :rules="[RULES.required, RULES.mrp]"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Qty"
                    required
                    v-model="s_qty"
                    :rules="[RULES.required, RULES.mrp]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                label="Total ₹"
                required
                readonly
                v-model="s_total"
                :rules="[RULES.required, RULES.mrp]"
              ></v-text-field>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="newStock = false">Close</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary1" block dark @click="newStockAdd">ADD</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      newStock: false,
      editStockDialog: false,
      search: "",
      indate: "",
      datemenu: false,
      headers: [
        {
          text: "VENDOR",
          align: "start",
          sortable: false,
          value: "v_name",
        },
        {
          text: "INVOICE DATE",
          align: "start",
          sortable: false,
          value: "in_date",
        },
        {
          text: "INVOICE NO",
          align: "start",
          sortable: false,
          value: "in_no",
        },
        {
          text: "INVOICE TOTAL  ₹",
          align: "start",
          sortable: false,
          value: "billrate",
        },
        {
          text: "ADDED ON",
          align: "start",
          sortable: false,
          value: "createdon",
        },
        {
          text: "VIEW",
          align: "start",
          value: "uniq_id",
        },
        {
          text: "ACTION",
          align: "start",
          value: "id",
        },
      ],
      s_product: "",
      s_mrp: 1,
      s_qty: 1,
      s_total: 1,
      s_e_id: "",
      s_e_product: "",
      s_e_mrp: 1,
      s_e_qty: 1,
      s_e_total: 1,
    };
  },
  computed: {
    ...mapGetters(["STOCKROOM", "RULES", "PRODUCTS"]),
  },
  created() {},
  methods: {
    ...mapActions(["GET_STOREROOM", "NEW_STOREROOM", "DELETE_STOCK"]),
    getStock() {
      this.$store.commit("SET_LOADING", true);
      this.GET_STOREROOM().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    editStock(item) {
      this.s_e_id = item.s_id;
      this.s_e_product = item.p_id;
      this.s_e_mrp = item.per_rate;
      this.s_e_qty = item.qty;
      this.s_e_total = item.total;
      this.editStockDialog = true;
    },
    deleteStock(item) {
      // console.log(item);
      this.$store.commit("SET_LOADING", true);
      this.DELETE_STOCK({ id: item.id }).then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    viewStock(val) {
      let routeData = this.$router.resolve({
        name: "STOREROOMSTOCK",
        params: { id: val },
      });
      window.open(routeData.href, "_blank");
    },
    newStockAdd() {
      if (this.$refs.form.validate()) {
        this.$store.commit("SET_LOADING", true);
        this.NEW_STOREROOM({
          pid: this.s_product,
          qty: this.s_qty,
          mrp: this.s_mrp,
          total: this.s_total,
        }).then(() => {
          this.s_product = "";
          this.s_qty = "";
          this.s_mrp = "";
          this.s_total = "";
          this.$store.commit("SET_LOADING", false);
        });
      }
    },
  },
  watch: {
    s_mrp(val) {
      if (val >= 1) {
        this.s_total = (Number(val) * Number(this.s_qty)).toFixed(2);
      } else {
        this.s_total = 0;
      }
    },
    s_qty(val) {
      if (val >= 1) {
        this.s_total = (Number(val) * Number(this.s_mrp)).toFixed(2);
      } else {
        this.s_total = 0;
      }
    },
  },
};
</script>

<style></style>
